import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { ListTeamsOutput, WebAppRoutes } from "types/web-app";

export const listPokeTeams = async (accessToken: string) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.LIST_POKE_TEAMS,
      accessToken,
    );

    const data = (await response.json()) as ServiceResponse<ListTeamsOutput>;

    return data;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
